export default __webpack_public_path__ + "static/media/BJ.221e47a9.txt";